import moment from 'moment';
import _ from 'lodash';

export default function (date, calendarConfig) {
  if (_.isString(date)) {
    date = moment(date, 'YYYY-MM-DD HH:mm:ss').toDate();
  } else {
    date = new Date(date);
  }

  const tempHours = calendarConfig.parsed.hours;
  const endHours = date.getHours();

  let workHoursInDay = false;
  const hoursLength = tempHours.length;

  for (let i = 0; i < hoursLength; i += 1) {
    const startH = tempHours[i].startHour;
    const endH = tempHours[i].end / (60 * 60);

    for (let j = startH; j <= endH; j += 1) {
      if (j === endHours) {
        workHoursInDay = true;
      }
    }
  }

  return workHoursInDay;
}
